export default __webpack_public_path__ + "static/media/icon_buscar_blanco.db16c8e4.svg";